module.exports = __webpack_public_path__ + "img/GitHub.28370d67.png";